import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { RewardsStyleVariant, WithStyleVariant } from '../types';

const RewardsTitleContainer = styled.div<WithStyleVariant>`
  width: 100%;
  margin: 0 0 1rem 0;

  font-size: 1rem;
  font-weight: ${Styles.fontWeight.heavy};
  color: ${({ variant }) =>
    variant === RewardsStyleVariant.Secondary ? Styles.color.white : Styles.color.secondary};
`;

const RewardPoints = styled.div`
  font-size: 1.5rem;
`;

const RewardCateogryDropdownHeader: React.FC<{ points?: number } & WithStyleVariant> = ({
  variant = RewardsStyleVariant.Primary,
  points = 0,
}) => {
  const { formatMessage } = useIntl();
  return (
    <RewardsTitleContainer variant={variant} tabIndex={0}>
      <div>{formatMessage({ id: 'loyaltyHelp' })}</div>
      <RewardPoints>{formatMessage({ id: 'loyaltyDropdownPoints' }, { points })}</RewardPoints>
    </RewardsTitleContainer>
  );
};

export default RewardCateogryDropdownHeader;
